import { Component, ViewEncapsulation, inject } from "@angular/core";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { GlobalStateService } from "./services/global-state.service";
import { SVGIcon, chevronDownIcon } from "@progress/kendo-svg-icons";
import {
  AppBarComponent,
  AppBarSectionComponent,
  AppBarSpacerComponent,
} from "@progress/kendo-angular-navigation";
import { DropDownListComponent } from "@progress/kendo-angular-dropdowns";
import { RouterOutlet } from "@angular/router";
import { VersionDisplayComponent } from "./CNP/classic/version-display/version-display.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [
    AppBarComponent,
    AppBarSectionComponent,
    AppBarSpacerComponent,
    DropDownListComponent,
    RouterOutlet,
    VersionDisplayComponent,
    TranslateModule,
  ],
})
export class AppComponent {
  globalStateSvc = inject(GlobalStateService);
  private translate = inject(TranslateService);

  public chevronDown: SVGIcon = chevronDownIcon;

  private frqLanguages = [
    { value: "enu", text: "Anglais" },
    { value: "frq", text: "Français" },
  ];

  private enuLanguages = [
    { value: "enu", text: "English" },
    { value: "frq", text: "French" },
  ];

  getLanguages(): Array<{ value: string; text: string }> {
    if (this.translate.currentLang == "frq") {
      return this.frqLanguages;
    } else {
      return this.enuLanguages;
    }
  }

  languageChange(langNameID) {
    this.translate.use(langNameID);
  }
}
